export const Kkconfig = {
  // ========== container ==========
  reqUrl: {
    dynApiUrl: document.querySelector('body').getAttribute('dau'),
    stApiUrl: document.querySelector('body').getAttribute('sau'),
    payUrl: document.querySelector('body').getAttribute('dau'),
    imgUrl: document.querySelector('body').getAttribute('igu'),
    imUrl: document.querySelector('body').getAttribute('imu')
  }
  // ========== local ==========
  // reqUrl: {
  //   dynApiUrl: 'http://localhost:8081',
  //   stApiUrl: 'http://localhost:8081',
  //   payUrl: 'http://localhost:8081',
  //   imgUrl: 'http://img.cmsuggc.com',
  //   imUrl: 'https://www.baidu.com'
  // }
  // ========== test ==========
  // reqUrl: {
  //   dynApiUrl: 'http://api.cmsuggc.com',
  //   stApiUrl: 'http://api.cmsuggc.com',
  //   payUrl: 'http://api.cmsuggc.com',
  //   imgUrl: 'http://img-app.cmsuggc.com',
  //   imUrl: 'about:blank'
  // }
}
